import * as types from '../actions/types';

const initialState = {
  notificationVisible: false,
  notificationData: { status: null, message: null },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.NOTIFICATION:
      return {
        ...state,
        notificationVisible: true,
        notificationData: action.payload.notificationData,
      };
    case types.RESET_NOTIFICATION:
      return initialState;
    default:
      return state;
  }
};
